module.exports = __webpack_public_path__ + "static/media/reception.1795fac3.jpg";